
































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import CharacterIcon from '@/components/parts/CharacterIcon.vue';
import * as api from '@/api/api';
import * as def from '@/common/definitions';
import ArrayUtil from '@/models/common/arrayutil';
import Enumerable from 'linq';

class FormationListItem {
  public constructor(public type: def.FormationType,
                     public data: api.Formation) {}
}

@Component({
  components: {
    CharacterIcon,
  },
})
export default class FormationList extends Vue {
  @Prop() public currentFormationType!: number;
  @Prop() public formations!: api.Formation[];
  public formationTypes: def.FormationType[] = [];
  public selectableFormationTypes: FormationListItem[] = [];
  public newFormationTypes: def.FormationType[] = [];
  public currentFormation: api.Formation = new api.Formation(-1);
  public currentFormationTypeInfo: def.FormationType = new def.FormationType(-1);
  @Prop({
    default: () => new def.FormationType(-1),
  }) public value!: def.FormationType;
  @Prop({
    default: true,
  }) public canChange!: boolean;
  @Prop({
    default: true,
  }) public isShowChangePoint!: boolean;
  @Prop({
    default: true,
  }) public canAdd!: boolean;
  @Prop({
    default: true,
  }) public canAddSelect!: boolean;
  @Prop({
    default: () => [],
  }) public skills!: api.CharacterSkill[];

  public get currentFormationCount(): number {
    const defaultFormation = def.FORMATION_TYPES[0];
    return this.formations.filter((f) => f.type !== defaultFormation.id).length;
  }

  public get formationMax(): number {
    return this.skills.some((s) => s.type === 36) ? 4 : 2;
  }

  @Watch('formations')
  @Watch('currentFormationType')
  public onFormationChanged() {
    this.formationTypes = Enumerable
      .from(this.formations)
      .select((p) => Enumerable.from(def.FORMATION_TYPES).firstOrDefault((pp) => pp.id === p.type))
      .toArray();
    this.selectableFormationTypes = Enumerable
      .from(this.formations)
      .where((f) => f.type !== this.currentFormationType)
      .join(def.FORMATION_TYPES, (f) => f.type, (f) => f.id, (fd, fi) => new FormationListItem(fi, fd))
      .toArray();
    this.newFormationTypes = Enumerable
      .from(def.FORMATION_TYPES)
      .where((f) => !Enumerable.from(this.formationTypes).any((ff) => ff.id === f.id))
      .where((f) => f.canGet)
      .where((f) => f.subjectAppear === undefined || f.subjectAppear(this.formations))
      .orderBy((f) => f.type)
      .toArray();
    this.currentFormation = Enumerable
      .from(this.formations)
      .firstOrDefault((f) => f.type === this.currentFormationType);
    this.currentFormationTypeInfo = Enumerable
      .from(def.FORMATION_TYPES)
      .firstOrDefault((f) => f.id === this.currentFormationType);
    if (!this.currentFormationTypeInfo) {
      this.currentFormationTypeInfo = Enumerable.from(def.FORMATION_TYPES).first((f) => f.id === 0);
    }
  }

  private created() {
    this.onFormationChanged();
  }
}
